import { RESOURCES_BASE } from './constants'

export interface InsidePage {
  src: string
  alt: string
}

/** Five interior pages of the product (1792×2240, 4:5). Illustrations pédagogiques. */
export const insidePages: InsidePage[] = [
  { src: RESOURCES_BASE + '1793830874750_p1-anatomie-thorax-55c99159.jpg', alt: 'Le thorax de face : les repères à identifier — Module 1' },
  { src: RESOURCES_BASE + '1793830888652_p3-densites-scanner-9c407bc4.jpg', alt: 'Scanner : l’échelle des densités — Module 2' },
  { src: RESOURCES_BASE + '1793830896025_p4-irm-t1-t2-a508d1fa.jpg', alt: 'IRM : T1 ou T2 ? — Module 2' },
  { src: RESOURCES_BASE + '1793830882004_p2-lecture-thorax-55840fed.jpg', alt: 'Lire une radio du thorax sans rien oublier — Module 3' },
  { src: RESOURCES_BASE + '1793830902591_p5-genou-incidence-2666916e.jpg', alt: 'Genou de face : critères de réussite — Module 4' },
]
